export const getters = {
  getContacts($state) {
    return $state.sortOrder.map(contactId => $state.records[contactId]);
  },
  getUIFlags($state) {
    return $state.uiFlags;
  },
  /**
   * A contact's presence from the last snapshot: 'online', or undefined when not online — and
   * `null` for EVERY contact until the first snapshot arrives, so a caller can tell "offline" from
   * "not known yet". See `presence` in index.js.
   */
  getContactPresence: $state => id => {
    if ($state.presence === null) return null;
    return $state.presence[id];
  },
  getContact: $state => id => {
    const contact = $state.records[id];
    return contact || {};
  },
  getMeta: $state => {
    return $state.meta;
  },
  getAppliedContactFilters: _state => {
    return _state.appliedFilters;
  },
};
